import type { ToolType } from '@repo/rpc-types-creativefabrica-studiomediamatrix-v1'
import { localStore } from 'utils/storage'

const FAVORITES_STORAGE_KEY = 'studio:favorite-tools'

export function loadFavoritesFromStorage(): Set<ToolType> {
  try {
    const raw = localStore.getString(FAVORITES_STORAGE_KEY)
    if (!raw) {
      return new Set()
    }
    return new Set(JSON.parse(raw) as ToolType[])
  } catch {
    return new Set()
  }
}

export function saveFavoritesToStorage(favorites: Set<ToolType>) {
  localStore.setJSON(FAVORITES_STORAGE_KEY, [...favorites])
}
